export default __webpack_public_path__ + "static/media/uncheckd.cc0da07b.svg";